const items = [
  {
    itemId: 1,
    title: 'Pink Bomber Jacket',
    location: 'London',
    email: 'billybob@gmails.com',
    phone: '0789369923',
    image: {
      img: './images/bomber jacket.jpeg',
      alt: 'Pink bomber jacket',
    },
    description:
      "Very nice jacket, worn only once, unfortunately, it's too small now",
  },
  {
    itemId: 2,
    title: 'Wooden Night Stand',
    location: 'Birmingham',
    email: 'billybob@gmails.com',
    phone: '0789369912',
    image: {
      img: './images/wooden night stand.jpeg',
      alt: 'Wooden night stand',
    },
    description: "Very good condition, but I don't have space for it :(",
  },
  {
    itemId: 3,
    title: 'Old PS4 Console',
    location: 'Liverpool',
    email: 'billybob@gmails.com',
    phone: '0789369000',
    image: {
      img: './images/old console.jpeg',
      alt: 'PS4 console',
    },
    description: 'Old but still useable',
  },
  {
    itemId: 4,
    title: 'Vintage Mirror with Gold Frame',
    location: 'Brighton',
    email: 'billybob@gmails.com',
    phone: '0789369999',
    image: {
      img: './images/vintage mirror.jpeg',
      alt: 'Mirror with gold frame',
    },
    description:
      'Matches with everything! But I was given a bigger one so can give this one away',
  },
  {
    itemId: 5,
    title: 'Unicorn Backpack for Kids',
    location: 'Newcastle',
    email: 'billybob@gmails.com',
    phone: '0789369988',
    image: {
      img: "./images/kid's backpack.jpeg",
      alt: 'Unicorn backpack',
    },
    description:
      'Good condition, no holes or anything. Made from sturdy material and very cute for a little girl that likes unicorns!',
  },
  {
    itemId: 6,
    title: 'Pair of Coffee/Tea Mugs',
    location: 'Nottingham',
    email: 'billybob@gmails.com',
    phone: '0789369977',
    image: {
      img: './images/mugs.jpeg',
      alt: 'White mugs for tea and coffee',
    },
    description:
      'Tea mug is a little bit chipped but still pretty good condition.',
  },
  {
    itemId: 7,
    title: 'Black Mountain Bike',
    location: 'Oxford',
    email: 'billybob@gmails.com',
    phone: '0789369977',
    image: {
      img: './images/bike.jpg',
      alt: 'black mountain bike',
    },
    description:
      "I'm not into bikes anymore so happy to give this one away or exchange for something cool! Like a camera because I would like to get into photography now",
  },
  {
    itemId: 8,
    title: 'Black Sony Camera',
    location: 'Cambridge',
    email: 'billybob@gmails.com',
    phone: '0789369966',
    image: {
      img: './images/camera.jpg',
      alt: 'Professional Camera',
    },
    description:
      'Willing to exchange for something that is similar in value.. like a bike lol',
  },
  {
    itemId: 9,
    title: 'Grey Chair',
    location: 'Surrey',
    email: 'billybob@gmails.com',
    phone: '0789369955',
    image: {
      img: './images/chair.jpg',
      alt: 'Small grey chair',
    },
    description:
      'Tiny scratch at the back (cats right?) but very comfy and soft to sit in.',
  },
  {
    itemId: 10,
    title: 'Dice for Board Games',
    location: 'Sheffield',
    email: 'billybob@gmails.com',
    phone: '0789369944',
    image: {
      img: './images/dice.jpg',
      alt: 'collection of dices',
    },
    description: 'We lost the actual game board so yeah...',
  },
  {
    itemId: 11,
    title: 'Gaming Mouse',
    location: 'Leicester',
    email: 'billybob@gmails.com',
    phone: '0789369933',
    image: {
      img: './images/mouse.jpg',
      alt: 'mouse for computer gamers',
    },
    description: 'A bit used but still very good condition',
  },
  {
    itemId: 12,
    title: 'Nike Trainers',
    location: 'Kent',
    email: 'billybob@gmails.com',
    phone: '0789369922',
    image: {
      img: './images/trainers.jpg',
      alt: 'Nike trainers',
    },
    description:
      'Worn only couple of times but they are still clean and quite comfortable.',
  },
];

export default items;
